module.exports = __webpack_public_path__ + "img/03.e0d673bc.jpg";